module.exports = __webpack_public_path__ + "img/l_c4.5d000bc1.png";